<!--DESKTOP-->
<ng-container *ngIf="!isTouchExperience">
  <app-usf-product-card-desktop
    [vm]="{
      mode: mode,
      product: addHideQuantityToProduct(),
      itemType: itemTypes.product,
      index,
      pricingDisabled: product?.selectedCustomer?.ogPrintPriceInd === 'N',
      isSelected: product?.selected,
      isOnline: (panAppState.online$ | async),
      checkboxDisabled: product.disabled,
      overrideModeCheck,
    }"
    [powerReviewRollupModel]="getPowerReviewRollupModel()"
    [alternatePowerReviewRollupModel]="getAlternativePowerReviewRollupModel()"
    (quantityUpdateEmitter)="changeQuantityHandler($event)"
    (productCardClickEmitter)="doProductCardClick($event)"
    (ellipsisEmitter)="openProductCardEllipsis($event)"
    (promotionClickEmitter)="clickPromotions($event)"
    (infoIconClickEmitter)="openProductStatus($event)"
    [isGuestUser]="isGuestUser$ | async"
  >
    <ion-checkbox
      mode="ios"
      *ngIf="selectable"
      [ngModel]="product.selected"
      (ngModelChange)="handleSelectionChange($event)"
      data-cy="product-card-check-box"
      [disabled]="product.disabled"
    >
    </ion-checkbox>
  </app-usf-product-card-desktop>
</ng-container>
<!--TOUCH-->
<ng-container *ngIf="isTouchExperience">
  <app-usf-product-card-touch
    [vm]="{
      mode: mode,
      product: addHideQuantityToProduct(),
      itemType: itemTypes.product,
      index,
      pricingDisabled: product?.selectedCustomer?.ogPrintPriceInd === 'N',
      isSelected: product?.selected,
      isOnline: (panAppState.online$ | async),
      checkboxDisabled: product.disabled,
      overrideModeCheck,
    }"
    [powerReviewRollupModel]="getPowerReviewRollupModel()"
    (quantityUpdateEmitter)="changeQuantityHandler($event)"
    (productCardClickEmitter)="doProductCardClick($event)"
    (ellipsisEmitter)="openProductCardEllipsis($event)"
    (promotionClickEmitter)="clickPromotions($event)"
    (infoIconClickEmitter)="openProductStatus($event)"
    [isGuestUser]="isGuestUser$ | async"
  >
    <ion-checkbox
      mode="ios"
      *ngIf="selectable"
      [ngModel]="product.selected"
      (ngModelChange)="handleSelectionChange($event)"
      data-cy="product-card-check-box"
      [disabled]="product.disabled"
    >
    </ion-checkbox>
  </app-usf-product-card-touch>
</ng-container>
